import { Component, inject, OnInit }                           from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatIcon }                                             from '@angular/material/icon';
import { MatProgressSpinner }                                  from '@angular/material/progress-spinner';
import { MatError, MatFormField, MatLabel }                    from '@angular/material/form-field';
import { MatInput }                                            from '@angular/material/input';

import { ComponentType }               from '../../../../../shared/components/components.utils';
import { ButtonComponent, ButtonType } from '../../../../../shared/components/buttons/button.component';
import { AuthenticationService }       from '../../../../../core/auth/authentication.service';
import { AutoFocusDirective }          from '../../../../../shared/directives/auto-focus.directive';
import { PinNotificationComponent }    from '../../../../../shared/components/notification/notification.component';
import { ErrorService }                from '../../../../../core/error-handling/error.service';

enum ForgotUsernamePageState { INITIAL, SUCCESS}

@Component({
  selector: 'pin-forgot-username',
  templateUrl: './forgot-username.component.html',
  imports: [ReactiveFormsModule, MatFormField, MatLabel, MatInput, AutoFocusDirective, MatError, ButtonComponent, MatIcon, MatProgressSpinner, PinNotificationComponent]
})
export class ForgotUsernameComponent implements OnInit {
  processingRequest = false;
  hasError = false;
  logoType = ComponentType;
  buttonType = ButtonType;
  state = ForgotUsernamePageState.INITIAL;
  initState = ForgotUsernamePageState;
  private authService = inject(AuthenticationService);
  private errorService = inject(ErrorService);
  private formBuilder = inject(UntypedFormBuilder);
  public forgotUsernameForm = this.formBuilder.group({
    email: ['', [Validators.required, Validators.email]]
  });

  ngOnInit() {
    this.hasError = false;
  }

  retrieveUsername() {
    if (!this.forgotUsernameForm.valid || this.processingRequest) {
      return;
    }
    this.processingRequest = true;
    this.authService.forgotUsername(this.forgotUsernameForm.value['email'])
      .subscribe({
        next: () => {
          this.processingRequest = false;
          this.hasError = false;
          this.state = ForgotUsernamePageState.SUCCESS;
        },
        error: error => {
          this.processingRequest = false;
          this.state = ForgotUsernamePageState.INITIAL;
          if (this.errorService.isInfrastructureError(error)) {
            this.hasError = true;
            window.scroll(0, 0);
          } else {
            throw error;
          }
        }
      });
  }

}
